export const CATEGORIES = {
  EMPLOYMENT: '9000',
  REAL_ESTATE: '3000',
  MOTOR: '1000',
}
